export const getPathnameWithoutPageNumber = (pathname: string) =>
  pathname.replace(/\/\d+\/?$/, '');
